import { Carousel } from '@fancyapps/ui'
import { equalizeHeights } from '../modules/equalize-height.js'
// import 'slick-carousel';

const slider = document.querySelector('.js-slider')
const sliderBoxes = document.querySelectorAll('.js-slider-boxes')
const sliderTiles = document.querySelectorAll('.js-slider-tiles')

if (slider !== null) {
  const sliderSlides = slider.querySelector('.slider .slider__slides')
  const sliderIndex = slider.querySelector('.slider__index')
  const sliderCount = slider.querySelector('.slider__count')
  const cardReason = slider.querySelector('.card-reason')
  let cardReasonHeight = cardReason.offsetHeight + 'px'
  const sliderShowTrigger = document.querySelector('.js-slider-show')

  const sliderCards = new Carousel(sliderSlides, {
    slidesPerPage: 1,
    navigation: true,
    dots: false,
    infinite: false,
    on: {
      init: (carousel) => {
        carousel.$index = sliderIndex
        carousel.$count = sliderCount
      },
      refresh: (carousel) => {
        if (carousel.$count) {
          carousel.$count.innerHTML = carousel.pages.length
        }
      },
      change: (carousel) => {
        if (carousel.$index) {
          carousel.$index.innerHTML = carousel.page + 1
        }
      },
    },
  })


  window.addEventListener('load', function () {
    equalizeHeights('.section-slider .card-reason')
    cardReasonHeight = cardReason.offsetHeight + 'px'
    slider.style.height = cardReasonHeight
  })

  window.addEventListener('resize', function () {
    equalizeHeights('.section-slider .card-reason')
    cardReasonHeight = cardReason.offsetHeight + 'px'
    slider.style.height = cardReasonHeight
  })

  sliderShowTrigger.addEventListener('click', function (evt) {
    evt.preventDefault()
    const card = this.closest('.card-reason')
    card.classList.add('fade-out')
  })
}



if(sliderBoxes !== null) {
  sliderBoxes.forEach((boxSlider) => {
    const sliderSlides = boxSlider.querySelector('.slider__slides')

    const slider = new Carousel(sliderSlides, {
      Dots: false,
      Navigation: true,
      infinite: true,
      center: false,
      breakpoints: {
        '(min-width: 959px)': {
     				dragFree: true,
          adaptiveHeight: true,
     				center: true,
     			},
      },
    })
  })
}

if(sliderTiles !== null) {
  sliderTiles.forEach((tilesSlider) => {
    const sliderSlides = tilesSlider.querySelector('.slider__slides')

    const slider = new Carousel(sliderSlides, {
      Dots: false,
      Navigation: true,
      infinite: true,
      center: false,
    })
  })
}
